import React, { Component } from 'react';
import logoFb from './facebookLogo.png';
import logoInstagram from './instagramLogo.png';
import logoTwitter from './twitterLogo.png';

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <a className={this.props.className} target="_blank" href={this.props.socialLink}>
        {this.props.socialNetworkName == "facebook" &&
          <img src={logoFb} alt={this.props.socialNetworkName} />
        }
        {this.props.socialNetworkName == "instagram" &&
          <img src={logoInstagram} alt={this.props.socialNetworkName} />
        }
        {this.props.socialNetworkName == "twitter" &&
          <img src={logoTwitter} alt={this.props.socialNetworkName} />
        }
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SocialImg/SocialImg.jsx